export default "__VITE_ASSET__1ada1733__"